
export const types = {
    GET_SETTING: 'GET_SETTING',
    GET_SETTING_COMPLETE: 'GET_SETTING_COMPLETE',

    UPLOAD: 'UPLOAD',

    LOGIN: 'LOGIN',

    GET_TOKEN_CDN: 'GET_TOKEN_CDN',

    GET_DATA_FORM: 'GET_DATA_FORM',

    GET_THEME: 'GET_THEME',
    GET_THEME_COMPLETE: 'GET_THEME_COMPLETE',

    CHANGE_THEME: 'CHANGE_THEME',
    CHANGE_THEME_COMPLETE: 'CHANGE_THEME_COMPLETE',

    UPDATE_FILTER: 'UPDATE_FILTER',
    UPDATE_FILTER_COMPLETE: 'UPDATE_FILTER_COMPLETE',
};

export function loading(cb) {
    return{
        type: types.GET_SETTING,
        cb
    }
}

export function changeTheme(params) {
    return{
        type: types.CHANGE_THEME,
        params
    }
}

export function updateFilters(params) {
    return{
        type: types.UPDATE_FILTER,
        params
    }
}

export function upload(params, mode, token, cb) {
    return{
        type: types.UPLOAD,
        params,
        mode,
        token,
        cb
    }
}

export function login(params, cb) {
    return{
        type: types.LOGIN,
        params,
        cb
    }
}

export function getTokenCDN(cb) {
    return{
        type: types.GET_TOKEN_CDN,
        cb
    }
}

export function getTheme(cb) {
    return{
        type: types.GET_THEME,
        cb
    }
}
